
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityEtapasEmpresa } from "./entity-etapas-empresa.model";
import { Observable, of } from "rxjs";
import { environment } from "projects/registro-personas-empresas/src/environments/environment";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EntityEtapasEmpresaService {
  endpoint = 'etapasEmpresa';

  constructor(private http: HttpClient) { }

  getAll(): Observable<EntityEtapasEmpresa[]> {
    return this.http.get<EntityEtapasEmpresa[]>(`${environment.apiUrl}/${this.endpoint}/`)
      .pipe(
        catchError(() => {
          return of([
            {
              "id": 1,
              "codigo": "C",
              "nombre": "Campo"
            },
            {
              "id": 2,
              "codigo": "M",
              "nombre": "Maquinaria"
            },
            {
              "id": 3,
              "codigo": "P",
              "nombre": "Planta"
            },
            {
              "id": 4,
              "codigo": "S",
              "nombre": "Rótulo"
            }
          ])
        })
      )
  }

  add(item: EntityEtapasEmpresa): Observable<EntityEtapasEmpresa> {
    return this.http.post<EntityEtapasEmpresa>(`${environment.apiUrl}/${this.endpoint}/`, item);
  }

  delete(item: EntityEtapasEmpresa): Observable<EntityEtapasEmpresa> {
    return this.http.delete<EntityEtapasEmpresa>(`${environment.apiUrl}/${this.endpoint}/${item.id}/`);
  }

  update(item: EntityEtapasEmpresa): Observable<EntityEtapasEmpresa> {
    return this.http.patch<EntityEtapasEmpresa>(`${environment.apiUrl}/${this.endpoint}/${item.id}/`, item);
  }
}
